var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('doc.intro_title')))]),_c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('doc.intro_p1'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('doc.intro_p2'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('doc.intro_p3'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }